import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-274954de"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "height": "18px"
  }
}, "颜色开关：", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "height": "18px"
  }
}, "(所有数据均同初盘对比)", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "时间 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "0球 ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "1球 ", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "2球 ", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "3球 ", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "4球 ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "5球 ", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "6+球 ", -1));
const _hoisted_11 = {
  class: "contentWater"
};
const _hoisted_12 = {
  class: "contentWater"
};
const _hoisted_13 = {
  class: "contentWater"
};
const _hoisted_14 = {
  class: "contentWater"
};
const _hoisted_15 = {
  class: "contentWater"
};
const _hoisted_16 = {
  class: "contentWater"
};
const _hoisted_17 = {
  class: "contentWater"
};
const _hoisted_18 = {
  class: "contentWater"
};
const _hoisted_19 = {
  class: "contentWater"
};
const _hoisted_20 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_21 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_22 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_23 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_24 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_25 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_26 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_27 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_28 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_29 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_30 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_31 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_32 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_33 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_34 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_35 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_36 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_37 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_38 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_39 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_40 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_41 = {
  class: "contentWater"
};
const _hoisted_42 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_43 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_44 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_45 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_46 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_47 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_48 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_49 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_50 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_51 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_52 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_53 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_54 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_55 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_56 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_57 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_58 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_59 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_60 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_61 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_62 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "盘口 ", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "0.5 ", -1));
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "1.5 ", -1));
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "2.5 ", -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "3.5 ", -1));
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "4.5 ", -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "初盘 ", -1));
const _hoisted_71 = {
  class: "contentWater"
};
const _hoisted_72 = {
  class: "contentWater"
};
const _hoisted_73 = {
  class: "contentWater"
};
const _hoisted_74 = {
  class: "contentWater"
};
const _hoisted_75 = {
  class: "contentWater"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "终盘 ", -1));
const _hoisted_77 = {
  class: "contentWater"
};
const _hoisted_78 = {
  class: "contentWater"
};
const _hoisted_79 = {
  class: "contentWater"
};
const _hoisted_80 = {
  class: "contentWater"
};
const _hoisted_81 = {
  class: "contentWater"
};
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "走势 ", -1));
const _hoisted_83 = {
  class: "contentWater"
};
const _hoisted_84 = {
  class: "contentWater"
};
const _hoisted_85 = {
  class: "contentWater"
};
const _hoisted_86 = {
  class: "contentWater"
};
const _hoisted_87 = {
  class: "contentWater"
};
import { h, ref } from 'vue';
import { getTtgConvert, count, decryptData } from './calculation.js';
import axios from 'axios';
import LoadingView from './LoadingView.vue';
import TtgBJ from './TtgBJ.vue';
export default {
  __name: 'TtgConvert',
  setup(__props, {
    expose: __expose
  }) {
    const ttgList = ref([]);
    const initTtgConvert = ref({});
    const ttgConvert = ref({});
    const matchWater = ref({});
    const initMatchWater = ref({});
    const level = ref(1.88);
    const obj = ref({});
    const id = ref({});
    const loadingRef = ref(null);
    const modalRef = ref(null);
    const infoValue = ref({});
    const listFlag = ref(false);
    const waterList = ref([]);
    const colorFlag = ref(true);
    const clickInfo = () => {
      modalRef.value.show(ttgConvert.value, 0);
    };
    const pushTtgList = (list, matchId, waterList1, value) => {
      ttgList.value = list;
      id.value = matchId;
      infoValue.value = value;
      waterList.value = waterList1;
      getInitMatchGoalWater(waterList1[0], waterList1[waterList1.length - 1]);
      let columnsT = [];
      let name;
      let ttg;
      for (let i = 0; i < list.length; i++) {
        ttg = list[i];
        name = list[i].updateDate + "  " + list[i].updateTime;
        columnsT.push({
          text: name,
          value: name,
          obj: list[i],
          ttgSize: i
        });
      }
      obj.value = ttg;
      columns.value = columnsT;
      val.value = [name];
    };
    const getInitMatchGoalWater = async (waterInit, waterFast) => {
      try {
        let data1 = waterInit;
        initMatchWater.value = data1;
        initTtgConvert.value = {
          Up05: data1.ttgUp05,
          Down05: count(level.value, data1.ttgUp05, '-'),
          Up15: data1.ttgUp15,
          Down15: count(level.value, data1.ttgUp15, '-'),
          Up25: data1.ttgUp25,
          Down25: count(level.value, data1.ttgUp25, '-'),
          Up35: data1.ttgUp35,
          Down35: count(level.value, data1.ttgUp35, '-'),
          Up45: data1.ttgUp45,
          Down45: count(level.value, data1.ttgUp45, '-')
        };
        let data = waterFast;
        matchWater.value = data;
        ttgConvert.value = {
          Up05: data.ttgUp05,
          Up05Rate: count(count(data.ttgUp05, initTtgConvert.value.Up05, "-"), initTtgConvert.value.Up05, '/'),
          Down05: count(level.value, data.ttgUp05, '-'),
          Up15: data.ttgUp15,
          Up15Rate: count(count(data.ttgUp15, initTtgConvert.value.Up15, "-"), initTtgConvert.value.Up15, '/'),
          Down15: count(level.value, data.ttgUp15, '-'),
          Up25: data.ttgUp25,
          Up25Rate: count(count(data.ttgUp25, initTtgConvert.value.Up25, "-"), initTtgConvert.value.Up25, '/'),
          Down25: count(level.value, data.ttgUp25, '-'),
          Up35: data.ttgUp35,
          Up35Rate: count(count(data.ttgUp35, initTtgConvert.value.Up35, "-"), initTtgConvert.value.Up35, '/'),
          Down35: count(level.value, data.ttgUp35, '-'),
          Up45: data.ttgUp45,
          Up45Rate: count(count(data.ttgUp45, initTtgConvert.value.Up45, "-"), initTtgConvert.value.Up45, '/'),
          Down45: count(level.value, data.ttgUp45, '-')
        };
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const refreshList = () => {
      listFlag.value = !listFlag.value;
    };
    const getMatchGoalWater = async (matchId, ttgSize) => {
      try {
        loadingRef.value.show();
        const response = await axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/getMatchGoalWater?ttgSize=' + ttgSize, infoValue.value);
        let data = decryptData(response.data);
        matchWater.value = data;
        ttgConvert.value = {
          Up05: data.ttgUp05,
          Up05Rate: count(count(data.ttgUp05, initTtgConvert.value.Up05, "-"), initTtgConvert.value.Up05, '/'),
          Down05: count(level.value, data.ttgUp05, '-'),
          Up15: data.ttgUp15,
          Up15Rate: count(count(data.ttgUp15, initTtgConvert.value.Up15, "-"), initTtgConvert.value.Up15, '/'),
          Down15: count(level.value, data.ttgUp15, '-'),
          Up25: data.ttgUp25,
          Up25Rate: count(count(data.ttgUp25, initTtgConvert.value.Up25, "-"), initTtgConvert.value.Up25, '/'),
          Down25: count(level.value, data.ttgUp25, '-'),
          Up35: data.ttgUp35,
          Up35Rate: count(count(data.ttgUp35, initTtgConvert.value.Up35, "-"), initTtgConvert.value.Up35, '/'),
          Down35: count(level.value, data.ttgUp35, '-'),
          Up45: data.ttgUp45,
          Up45Rate: count(count(data.ttgUp45, initTtgConvert.value.Up45, "-"), initTtgConvert.value.Up45, '/'),
          Down45: count(level.value, data.ttgUp45, '-')
        };
        loadingRef.value.close();
      } catch (error) {
        // 处理错误
        console.error(error);
        loadingRef.value.close();
      }
    };
    const val = ref('');
    const columns = ref([]);
    const confirm = ({
      selectedValue,
      selectedOptions
    }) => {
      try {
        //ttgConvert.value = getTtgConvert(selectedOptions[0].obj, level.value);
        getMatchGoalWater(id.value, selectedOptions[0].ttgSize);
        obj.value = selectedOptions[0].obj;
      } catch (e) {}
    };
    const updateLevel = val => {
      try {
        ttgConvert.value = getTtgConvert(obj.value, val);
      } catch (e) {}
    };

    // 暴露给外部使用的函数
    __expose({
      pushTtgList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_var_switch = _resolveComponent("var-switch");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      const _component_nut_trend_arrow = _resolveComponent("nut-trend-arrow");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TtgBJ, {
        ref_key: "modalRef",
        ref: modalRef
      }, null, 512), _createVNode(LoadingView, {
        ref_key: "loadingRef",
        ref: loadingRef
      }, null, 512), _createVNode(_component_nut_divider, {
        "content-position": "left",
        style: {
          margin: '8px 0'
        }
      }, {
        default: _withCtx(() => [_createTextVNode("进球数计算器(括号内为初盘)")]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_var_switch, {
            size: "10",
            modelValue: colorFlag.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => colorFlag.value = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 16
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(initMatchWater.value.ttgTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(initMatchWater.value.ttgS0), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, _toDisplayString(initMatchWater.value.ttgS1), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, _toDisplayString(initMatchWater.value.ttgS2), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, _toDisplayString(initMatchWater.value.ttgS3), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(initMatchWater.value.ttgS4), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, _toDisplayString(initMatchWater.value.ttgS5), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(initMatchWater.value.ttgS6), 1)]),
          _: 1
        })]),
        _: 1
      }), listFlag.value ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(waterList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [index != 0 && index != waterList.value.length - 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_19, _toDisplayString(change.ttgTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS0 > initMatchWater.value.ttgS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(change.ttgS0), 1)) : change.ttgS0 < initMatchWater.value.ttgS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(change.ttgS0), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(change.ttgS0), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS1 > initMatchWater.value.ttgS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(change.ttgS1), 1)) : change.ttgS1 < initMatchWater.value.ttgS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(change.ttgS1), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(change.ttgS1), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS2 > initMatchWater.value.ttgS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(change.ttgS2), 1)) : change.ttgS2 < initMatchWater.value.ttgS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(change.ttgS2), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(change.ttgS2), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS3 > initMatchWater.value.ttgS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(change.ttgS3), 1)) : change.ttgS3 < initMatchWater.value.ttgS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(change.ttgS3), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(change.ttgS3), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS4 > initMatchWater.value.ttgS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(change.ttgS4), 1)) : change.ttgS4 < initMatchWater.value.ttgS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(change.ttgS4), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(change.ttgS4), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS5 > initMatchWater.value.ttgS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(change.ttgS5), 1)) : change.ttgS5 < initMatchWater.value.ttgS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(change.ttgS5), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(change.ttgS5), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.ttgS6 > initMatchWater.value.ttgS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(change.ttgS6), 1)) : change.ttgS6 < initMatchWater.value.ttgS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(change.ttgS6), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(change.ttgS6), 1))]),
            _: 2
          }, 1024)], 64)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024);
      }), 128)) : _createCommentVNode("", true), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_41, _toDisplayString(matchWater.value.ttgTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS0 > initMatchWater.value.ttgS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(matchWater.value.ttgS0), 1)) : matchWater.value.ttgS0 < initMatchWater.value.ttgS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(matchWater.value.ttgS0), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(matchWater.value.ttgS0), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS1 > initMatchWater.value.ttgS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(matchWater.value.ttgS1), 1)) : matchWater.value.ttgS1 < initMatchWater.value.ttgS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(matchWater.value.ttgS1), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(matchWater.value.ttgS1), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS2 > initMatchWater.value.ttgS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(matchWater.value.ttgS2), 1)) : matchWater.value.ttgS2 < initMatchWater.value.ttgS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(matchWater.value.ttgS2), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(matchWater.value.ttgS2), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS3 > initMatchWater.value.ttgS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(matchWater.value.ttgS3), 1)) : matchWater.value.ttgS3 < initMatchWater.value.ttgS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(matchWater.value.ttgS3), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(matchWater.value.ttgS3), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS4 > initMatchWater.value.ttgS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(matchWater.value.ttgS4), 1)) : matchWater.value.ttgS4 < initMatchWater.value.ttgS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(matchWater.value.ttgS4), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(matchWater.value.ttgS4), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS5 > initMatchWater.value.ttgS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(matchWater.value.ttgS5), 1)) : matchWater.value.ttgS5 < initMatchWater.value.ttgS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(matchWater.value.ttgS5), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(matchWater.value.ttgS5), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.ttgS6 > initMatchWater.value.ttgS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(matchWater.value.ttgS6), 1)) : matchWater.value.ttgS6 < initMatchWater.value.ttgS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(matchWater.value.ttgS6), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(matchWater.value.ttgS6), 1))]),
          _: 1
        })]),
        _: 1
      }), waterList.value.length > 2 ? (_openBlock(), _createBlock(_component_var_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_var_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "refresh",
            onClick: refreshList
          }, [!listFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode("点击加载更多历史数据")], 64)) : _createCommentVNode("", true), listFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode("点击收起历史数据")], 64)) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _hoisted_63, _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_64]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_65]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_66]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_67]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_68]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_69]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_70]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_71, _toDisplayString(initTtgConvert.value.Up05), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_72, _toDisplayString(initTtgConvert.value.Up15), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_73, _toDisplayString(initTtgConvert.value.Up25), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_74, _toDisplayString(initTtgConvert.value.Up35), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_75, _toDisplayString(initTtgConvert.value.Up45), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_76]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_77, _toDisplayString(ttgConvert.value.Up05), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_78, _toDisplayString(ttgConvert.value.Up15), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_79, _toDisplayString(ttgConvert.value.Up25), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_80, _toDisplayString(ttgConvert.value.Up35), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_81, _toDisplayString(ttgConvert.value.Up45), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_82]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_83, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up05Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_84, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up15Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up25Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up35Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up45Rate
          }, null, 8, ["rate"])])]),
          _: 1
        })]),
        _: 1
      })], 64);
    };
  }
};